import { create } from 'zustand';
import { Resources } from '../../../models/ScheduleResource';

interface IStore {
  products: Resources[];
  setProducts: (props: Resources[]) => void;
  selectedProduct?: Resources;
  setSelectedProduct: (props: Resources) => void;
}

export const useProducts = create<IStore>(set => ({
  products: [],
  setProducts: products => set(() => ({ products })),
  setSelectedProduct: selectedProduct => set(() => ({ selectedProduct }))
}));
